/* SKN&B wishlist — app-free, localStorage. Heart toggle + slide-out drawer. */
(function () {
  var KEY = 'sknb_wishlist_v1';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    updateCounts(list);
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: list } }));
  }
  function has(h) { return read().indexOf(h) > -1; }
  function toggle(h) { var l = read(); var i = l.indexOf(h); if (i > -1) { l.splice(i, 1); } else { l.push(h); } write(l); return l.indexOf(h) > -1; }
  function updateCounts(list) {
    var c = (list || read()).length;
    var s = String(c);
    var hide = c === 0;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      if (el.textContent !== s) el.textContent = s;
      if (el.hasAttribute('hidden') !== hide) el.toggleAttribute('hidden', hide);
    });
  }

  function getDrawer() { return document.querySelector('wishlist-drawer'); }
  function openDrawer() { var d = getDrawer(); if (d && d.openDrawer) d.openDrawer(); }

  window.SknbWishlist = { read: read, write: write, has: has, toggle: toggle, open: openDrawer };

  /* Open the drawer from any [data-wishlist-open] trigger (e.g. the header heart). */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-wishlist-open]') : null;
    if (t) { e.preventDefault(); openDrawer(); }
  });

  /* Heart toggle — product cards + PDP. */
  class WishlistButton extends HTMLElement {
    connectedCallback() {
      this.handle = this.getAttribute('data-handle');
      if (!this.handle) return;
      this.sync();
      this.addEventListener('click', this.onClick.bind(this));
      this._onChange = this.sync.bind(this, undefined);
      document.addEventListener('wishlist:change', this._onChange);
    }
    disconnectedCallback() { document.removeEventListener('wishlist:change', this._onChange); }
    onClick(e) { e.preventDefault(); e.stopPropagation(); this.sync(toggle(this.handle)); }
    sync(active) {
      var on = active === undefined ? has(this.handle) : active;
      this.classList.toggle('is-active', on);
      var b = this.querySelector('button') || this;
      if (b.setAttribute) b.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }
  if (!customElements.get('wishlist-button')) customElements.define('wishlist-button', WishlistButton);

  /* Renders saved products (used inside the drawer). */
  class WishlistList extends HTMLElement {
    connectedCallback() {
      var params = new URLSearchParams(location.search);
      var shared = (params.get('w') || '').split(',').filter(Boolean);
      if (shared.length) { var cur = read(); shared.forEach(function (h) { if (cur.indexOf(h) === -1) cur.push(h); }); write(cur); }
      this.grid = this.querySelector('[data-wishlist-grid]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      this.shareBtn = this.querySelector('[data-wishlist-share]');
      if (this.shareBtn) this.shareBtn.addEventListener('click', this.share.bind(this));
      this._onChange = this.render.bind(this);
      document.addEventListener('wishlist:change', this._onChange);
      this.render();
    }
    disconnectedCallback() { document.removeEventListener('wishlist:change', this._onChange); }
    share() {
      var url = location.origin + location.pathname + '?w=' + encodeURIComponent(read().join(','));
      var self = this;
      function feedback() {
        if (!self.shareBtn) return;
        if (self._shareTimer) clearTimeout(self._shareTimer);
        if (self._shareOriginal == null) self._shareOriginal = self.shareBtn.textContent;
        self.shareBtn.textContent = self.shareBtn.getAttribute('data-copied') || 'Länk kopierad!';
        self.shareBtn.classList.add('is-copied');
        self._shareTimer = setTimeout(function () {
          self.shareBtn.textContent = self._shareOriginal;
          self.shareBtn.classList.remove('is-copied');
          self._shareTimer = null;
        }, 2000);
      }
      function copyFallback() {
        try {
          var ta = document.createElement('textarea');
          ta.value = url; ta.setAttribute('readonly', '');
          ta.style.position = 'absolute'; ta.style.left = '-9999px';
          document.body.appendChild(ta); ta.select();
          document.execCommand('copy'); document.body.removeChild(ta);
        } catch (e) {}
        feedback();
      }
      // Touch devices: native share sheet. Desktop: copy the link with clear feedback.
      var isTouch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      if (isTouch && navigator.share) {
        navigator.share({ title: document.title, url: url }).catch(function () {});
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(feedback).catch(copyFallback);
      } else {
        copyFallback();
      }
    }
    async render() {
      if (!this.grid) return;
      var list = read();
      this.toggleAttribute('is-empty', list.length === 0);
      if (this.empty) this.empty.toggleAttribute('hidden', list.length !== 0);
      if (this.shareBtn) this.shareBtn.toggleAttribute('hidden', list.length === 0);
      if (list.length === 0) { this.grid.innerHTML = ''; return; }
      var self = this;
      var cards = await Promise.all(list.map(function (h) { return self.card(h); }));
      this.grid.innerHTML = cards.filter(Boolean).join('');
    }
    async card(handle) {
      try {
        var removeLabel = (this.getAttribute('data-remove-label') || 'Ta bort').replace(/"/g, '&quot;');
        var p = await fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; });
        if (!p) return '';
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var imgSrc = img ? (img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=300') : '';
        var wlCur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SEK';
        var wlLoc = (window.Shopify && window.Shopify.locale) || 'sv';
        var price;
        try {
          price = new Intl.NumberFormat(wlLoc, { style: 'currency', currency: wlCur, minimumFractionDigits: (p.price % 100 === 0 ? 0 : 2), maximumFractionDigits: 2 }).format(p.price / 100);
        } catch (e) {
          price = (p.price / 100).toLocaleString('sv-SE', { minimumFractionDigits: 0 }) + ' kr';
        }
        var vendor = p.vendor ? '<span class="wl-card__vendor">' + p.vendor + '</span>' : '';
        var np = window.sknbNicePrice ? await window.sknbNicePrice() : new Set();
        var npChip = np.has(p.handle || handle) && window.sknbNicePriceBadge ? window.sknbNicePriceBadge('sm', true) : '';
        return '<li class="wl-card">' +
          '<a href="/products/' + handle + '" class="wl-card__media">' + (imgSrc ? '<img src="' + imgSrc + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="wl-card__info">' + npChip + vendor +
          '<a href="/products/' + handle + '" class="wl-card__title">' + p.title + '</a>' +
          '<span class="wl-card__price">' + price + '</span></div>' +
          '<wishlist-button class="wl-card__remove is-active" data-handle="' + handle + '"><button type="button" aria-label="' + removeLabel + '">&times;</button></wishlist-button>' +
          '</li>';
      } catch (e) { return ''; }
    }
  }
  if (!customElements.get('wishlist-list')) customElements.define('wishlist-list', WishlistList);

  /* Slide-out drawer. */
  class WishlistDrawer extends HTMLElement {
    connectedCallback() {
      this.setAttribute('aria-hidden', 'true');
      this.addEventListener('click', this.onClick.bind(this));
      this._onKey = function (e) { if (e.key === 'Escape' && this.classList.contains('is-open')) this.closeDrawer(); }.bind(this);
    }
    onClick(e) { if (e.target.closest('[data-wishlist-close]')) { e.preventDefault(); this.closeDrawer(); } }
    openDrawer() {
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKey);
      // Re-render the saved items in case a header morph/hydration reset the grid.
      var list = this.querySelector('wishlist-list');
      if (list && list.render) list.render();
      var c = this.querySelector('.wl-drawer__close');
      if (c) c.focus();
    }
    closeDrawer() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this._onKey);
    }
  }
  if (!customElements.get('wishlist-drawer')) customElements.define('wishlist-drawer', WishlistDrawer);

  // Keep the header count badge in sync even when the header section is
  // re-rendered/hydrated (Horizon morphs the DOM in place, resetting the
  // server-rendered "0"/hidden badge). updateCounts writes only on change, so
  // observing attributes/characterData below cannot loop.
  var _countRaf = null;
  function scheduleCounts() {
    if (_countRaf) return;
    _countRaf = requestAnimationFrame(function () { _countRaf = null; updateCounts(); });
  }
  scheduleCounts();
  document.addEventListener('DOMContentLoaded', scheduleCounts);
  window.addEventListener('load', scheduleCounts);
  window.addEventListener('pageshow', scheduleCounts);
  document.addEventListener('wishlist:change', scheduleCounts);
  try {
    new MutationObserver(scheduleCounts).observe(document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'], characterData: true
    });
  } catch (e) {}
  // Belt-and-suspenders: re-sync for a few seconds after load in case the header
  // section hydrates/morphs after our first pass.
  var _syncTicks = 0;
  var _syncTimer = setInterval(function () {
    updateCounts();
    if (++_syncTicks >= 16) clearInterval(_syncTimer);
  }, 300);
})();
